<div class="component-container">

    <!-- ── Encabezado ─────────────────────────────────────── -->
    <app-page-title [title]="title()"></app-page-title>

    <!-- ── Tarjetones ─────────────────────────────────────── -->
    <!-- Mismo tarjetón que el menú de Catálogos. A diferencia de allá, aquí
         no hay badge de conteo ni estados de carga: las tarjetas de reportes
         son una lista fija (REPORT_CARDS) y no dependen del rol ni de un
         search, así que no hay nada que esperar ni que contar. -->
    <div class="menu-container">
        <div class="grid-menu">
            @for (item of menuCards; track item.route) {
                <button
                    mat-button
                    color="primary"
                    class="menu-item-btn"
                    (click)="navigationTo(item.route)">
                    <div class="button-content">
                        <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
                        <span class="menu-label">{{ item.title }}</span>
                        <p class="menu-description">{{ item.description }}</p>
                    </div>
                </button>
            }
        </div>
    </div>
</div>
